export const NewsData = [
    {
        title:'적시타, 승리투수, 마무리까지!!! 불펜 활약 중',
        subscript:'#SSGLANDERS #SSG랜더스 SSG랜더스',
        date:'2025-05-20',
        img:`${process.env.PUBLIC_URL}/images/news_img01.jpg`,
    },
    {
        title:'앤더슨 6이닝 8K 무실점 완벽투+ 9득점 타선',
        subscript:'#SSGLANDERS #SSG랜더스 SSG랜더스',
        date:'2025-05-21',
        img:`${process.env.PUBLIC_URL}/images/news_img02.jpg`,
    },
    {
        title:'에레디아 3안타, 최정 홈런 쐬기포',
        subscript:'#SSGLANDERS #SSG랜더스 SSG랜더스',
        date:'2025-05-20',
        img:`${process.env.PUBLIC_URL}/images/news_img03.jpg`,
    },
    {
        title:' SSG랜더스, 시즌 열 두 번째 만원 관중 달성',
        subscript:'#SSGLANDERS #SSG랜더스 SSG랜더스',
        date:'	2025.06.22',
        img:`${process.env.PUBLIC_URL}/images/news_img04.jpg`,
    },
    {
        title:'SSG랜더스, 홈 개막 시리즈에 앞서 승리 기원 시구 진행',
        subscript:'#SSGLANDERS #SSG랜더스 SSG랜더스',
        date:'2025-05-21',
        img:`${process.env.PUBLIC_URL}/images/news_img05.jpg`,
    },
    {
        title:'SSG랜더스, 요기요와 F&B 파트너십 체결',
        subscript:'#SSGLANDERS #SSG랜더스 SSG랜더스',
        date:'2025-05-20',
        img:`${process.env.PUBLIC_URL}/images/news_img06.jpg`,
    },
]

export const SnsData = [
    {
        title:'최정 500홈런 기념 BEYOND 500 FESTIVAL with LANDY & FRIENDS',
        subscript:'행사 첫날인 17일(목)에는 ‘랜디와 친구들’ 콘셉트 데이로 진행된다. 야구장 곳곳에서 캐릭터들과의 특별한 만남이 준비되어 있으며, 캐릭터를 만난 팬들에게는 선착순으로 스크래치 복권 1,500장이 배포된다.   ',
        date:'2025.07.09',
        img:`${process.env.PUBLIC_URL}/images/sns_img1.jpg`,
    },
    {
        title:'SSG랜더스, 28일(토) 김강민 KBO 전력강화위원 은퇴식 개최',
        subscript:'이번 은퇴식은 ‘Remember the Beast(리멤버 더 비스트)’라는 테마로, 2022년 한국시리즈 최고령 MVP이자 인천에서 23시즌을 뛰며 SSG의 5차례 한국시리즈 우승에 기여한 김강민의 헌신과 여정을 기리기 위해 마련됐다. ',
        date:'2025.06.17',
        img:`${process.env.PUBLIC_URL}/images/sns_img2.jpg`,
    },
    {
        title:'‘빵야! SSG랜더스의 하루’ 카카오톡 이모티콘 출시',
        subscript:'이번 이모티콘은 팬들의 요청에 따라 제작됐다. SSG는 앞서 구단 마스코트 ‘랜디’를 활용한 이모티콘과 깜자 콜라보 이모티콘을 차례로 출시했다. 이후 팬들 사이에서 선수단이 등장하는 이모티콘도 출시해달라는 의견이 많아졌고, 이를 적극 반영해 새롭게 선보이게 됐다.',
        date:'2025.06.05',
        img:`${process.env.PUBLIC_URL}/images/sns_img3.jpg`,
    },
    {
        title:'‘SSG랜더스, 신규 마스코트 ‘푸리’와 ‘배티’ 영입',
        subscript:'‘푸리’는 랜디와 같은 반려견을 모티브로 한 캐릭터로, ‘제1회 인천 예쁜 강아지 선발대회 1위’이자 ‘댕댕이 팬클럽 회장’이라는 독특한 콘셉트를 갖고 있다. 랜디를 만나기 위해 인천SSG랜더스필드를 방문한 푸리는, 마스코트계의 셀럽이 되겠다는 꿈을 품고 활동을 시작했다.',
        date:'2025.07.08',
        img:`${process.env.PUBLIC_URL}/images/sns_img4.jpg`,
    },
    {
        title:'‘SSG, ‘라인프렌즈 미니니(minini)’와 함께 콜라보레이션 상품 출시',
        subscript:'‘푸리’는 랜디와 같은 반려견을 모티브로 한 캐릭터로, ‘제1회 인천 예쁜 강아지 선발대회 1위’이자 ‘댕댕이 팬클럽 회장’이라는 독특한 콘셉트를 갖고 있다. 랜디를 만나기 위해 인천SSG랜더스필드를 방문한 푸리는, 마스코트계의 셀럽이 되겠다는 꿈을 품고 활동을 시작했다.',
        date:'2025.07.08',
        img:`${process.env.PUBLIC_URL}/images/sns_img5.jpg`,
    },
    {
        title:'‘SSG랜더스, 구단 공식 트레이딩 카드 출시',
        subscript:'‘푸리’는 랜디와 같은 반려견을 모티브로 한 캐릭터로, ‘제1회 인천 예쁜 강아지 선발대회 1위’이자 ‘댕댕이 팬클럽 회장’이라는 독특한 콘셉트를 갖고 있다. 랜디를 만나기 위해 인천SSG랜더스필드를 방문한 푸리는, 마스코트계의 셀럽이 되겠다는 꿈을 품고 활동을 시작했다.',
        date:'2025.07.08',
        img:`${process.env.PUBLIC_URL}/images/sns_img6.jpg`,
    },

]